<div class="layout-container">
    <div class="content">
        <router-outlet></router-outlet>
    </div>
    <div class="layout-footer">
        <div class="div-left">
            <div class="topic">Beim Einkauf gespart:<br>CHF {{saved | number:'1.2-2'}}<br><br><span *ngIf="employee">davon Mitarbeiterrabatt:<br>CHF {{employee | number:'1.2-2'}}</span></div>
        </div>
        <div class="div-right" (click)="continue()">
            <div class="topic">{{currentRoute === '/basket' ? 'Hier klicken und bezahlen' : 'Zum Warenkorb'}} <i class="fa-solid fa-chevron-right"></i></div>
            <div *ngIf="!isLoading" class="amount">{{total | number:'1.2-2'}}<span>Total CHF</span></div>
            <div *ngIf="isLoading" class="loading">Loading<span>wird berechnet</span></div>
            <img *ngIf="!isLoading" src="/assets/images/tip.png">
        </div>
        <div class="border-triangle"></div>
    </div>
</div>
<div help-triangle></div>
<div modal [showModal]="showModal" (closeModal)="showModal = false"></div>